import { takeEvery, all, call, put } from 'redux-saga/effects';
import * as types from './shipmentStatusActionTypes';
import * as actions from './shipmentStatusActions';
import * as endpoints from '../../services/endpoints';
import { errorHandler } from '../../helpers/errorHandler';

function* getShipmentStatusSaga(action) {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const sessionUserId = localStorage.getItem('sessionUserId');
    const userId = sessionUserId || userData?.sessionUserId || userData?.user?.sessionUserId;

    if (!userId || userId === 'undefined') {
      yield put(actions.getShipmentStatusErrorAction({ message: 'User session not found.' }));
      return;
    }

    const payload = { SessionUserId: String(userId) };
    const { data } = yield call(endpoints.getShipmentStatus, payload);

    yield put(actions.getShipmentStatusDataAction(data));
  } catch (e) {
    yield put(actions.getShipmentStatusErrorAction(e));
    yield call(errorHandler, e, action.history, action.href);
  }
}

function* createShipmentStatusSaga(action) {
  try {
    console.log('createShipmentStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Create shipment status API payload:', payload);
    
    const { data } = yield call(endpoints.createShipmentStatus, payload);
    console.log('Create shipment status API response:', data);
    
    yield put(actions.createShipmentStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      setTimeout(() => {
        if (action.payload.navigate) {
          action.payload.navigate('/shipment-status');
        }
      }, 2000);
    }
    
  } catch (e) {
    console.error('createShipmentStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.createShipmentStatusErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* updateShipmentStatusSaga(action) {
  try {
    console.log('updateShipmentStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Update shipment status API payload:', payload);
    
    const { data } = yield call(endpoints.updateShipmentStatus, payload);
    console.log('Update shipment status API response:', data);
    
    yield put(actions.updateShipmentStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getShipmentStatusRequestAction());
      
      if (action.payload.navigate) {
        setTimeout(() => {
          action.payload.navigate('/shipment-status');
        }, 1000);
      }
    }
    
  } catch (e) {
    console.error('updateShipmentStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.updateShipmentStatusErrorAction(e));
    yield call(errorHandler, e);
  }
}

function* deleteShipmentStatusSaga(action) {
  try {
    console.log('deleteShipmentStatusSaga action:', action);
    
    const payload = action.payload.data;
    
    console.log('Delete shipment status API payload:', payload);
    
    const { data } = yield call(endpoints.deleteShipmentStatus, payload);
    console.log('Delete shipment status API response:', data);
    
    yield put(actions.deleteShipmentStatusDataAction(data));
    
    if (data.Result && data.Result.ErrorCode === 0) {
      yield put(actions.getShipmentStatusRequestAction());
    }
    
  } catch (e) {
    console.error('deleteShipmentStatusSaga error:', e);
    console.error('Error response:', e.response?.data);
    yield put(actions.deleteShipmentStatusErrorAction(e));
    yield call(errorHandler, e);
  }
}

export function* shipmentStatusSaga() {
  yield all([
    takeEvery(types.GET_SHIPMENT_STATUS_REQUEST, getShipmentStatusSaga),
    takeEvery(types.CREATE_SHIPMENT_STATUS_REQUEST, createShipmentStatusSaga),
    takeEvery(types.UPDATE_SHIPMENT_STATUS_REQUEST, updateShipmentStatusSaga),
    takeEvery(types.DELETE_SHIPMENT_STATUS_REQUEST, deleteShipmentStatusSaga),
  ]);
}
